import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ContextProvider from "./Components/ContextProvider";
import { HelmetProvider } from "react-helmet-async"; // ✅ Added for SEO meta tag management

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <ContextProvider>
      <App />
    </ContextProvider>
  </HelmetProvider>
);

// Performance reporting
reportWebVitals();
